import React, { useCallback, useContext } from 'react';
import {
  Boolean,
  Choice,
  Text,
  Group,
  TableGroup,
  Display,
  Photo,
  LifeologyCourse,
  Image,
  CheckboxGroup,
} from './ItemTypes/index';
import SurveyItem from '../util/SurveyItem';
import RadioButtonGroup from './ItemTypes/RadioButtonGroup';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { getTestProps } from '../../../util/testProps';
import { RegisterSurveyItemContainerRefContext } from './Contexts';
import GenomicsReport from './ItemTypes/GenomicsReport';

export interface SurveyItemComponentOwnProps {
  surveyItem: SurveyItem;
}

const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    width: '100%',
  },
}));

export type SurveyItemProps = SurveyItemComponentOwnProps;

export const SurveyItemComponent: React.FC<SurveyItemProps> = ({
  surveyItem,
}) => {
  const classes = useStyles({});
  const linkId = surveyItem.link;
  const registerSurveyItemContainer = useContext(
    RegisterSurveyItemContainerRefContext,
  );
  const registerRef = useCallback(
    (ref: HTMLDivElement) => {
      registerSurveyItemContainer(linkId, ref);
    },
    [linkId, registerSurveyItemContainer],
  );

  return (
    <div
      className={classes.root}
      ref={registerRef}
      {...getTestProps(`survey-surveyItemContainer-${surveyItem.link}`)}
    >
      {(() => {
        if (surveyItem.isTableGroup) {
          return <TableGroup surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'date') {
          return <Text surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'time') {
          return <Text surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'dateTime') {
          return <Text surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'group') {
          return <Group surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'boolean') {
          return <Boolean surveyItem={surveyItem} />;
        } else if (
          surveyItem.type === 'choice' &&
          surveyItem.isRadioButtonGroup &&
          !surveyItem.repeats
        ) {
          return <RadioButtonGroup surveyItem={surveyItem} />;
        } else if (
          surveyItem.type === 'open-choice' &&
          surveyItem.isRadioButtonGroup &&
          !surveyItem.repeats
        ) {
          return <RadioButtonGroup surveyItem={surveyItem} />;
        } else if (
          surveyItem.type === 'choice' &&
          surveyItem.isRadioButtonGroup &&
          surveyItem.repeats
        ) {
          return <CheckboxGroup surveyItem={surveyItem} />;
        } else if (
          surveyItem.type === 'open-choice' &&
          surveyItem.isRadioButtonGroup &&
          surveyItem.repeats
        ) {
          return <CheckboxGroup surveyItem={surveyItem} />;
        } else if (
          surveyItem.type === 'choice' &&
          !surveyItem.isRadioButtonGroup
        ) {
          return <Choice surveyItem={surveyItem} />;
        } else if (
          surveyItem.surveyBuilderQuestionType === 'lifeology-course'
        ) {
          // NOTE: It's important this goes above decimal, or other conditional logic
          // is introduced if reordered, because `lifeology-course` uses decimal type.
          return <LifeologyCourse surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'decimal') {
          return <Text surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'quantity') {
          return <Text surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'integer') {
          return <Text surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'text') {
          return <Text surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'string') {
          return <Text surveyItem={surveyItem} />;
        } else if (
          surveyItem.type === 'open-choice' &&
          surveyItem.surveyBuilderQuestionType !== 'genomics-report'
        ) {
          return <Choice surveyItem={surveyItem} />;
        } else if (surveyItem.surveyBuilderQuestionType === 'image') {
          return <Image surveyItem={surveyItem} />;
        } else if (surveyItem.type === 'display') {
          return <Display surveyItem={surveyItem} />;
        } else if (surveyItem.surveyBuilderQuestionType === 'photo') {
          return <Photo surveyItem={surveyItem} />;
        } else if (surveyItem.surveyBuilderQuestionType === 'genomics-report') {
          return <GenomicsReport surveyItem={surveyItem} />;
        } else {
          return null;
        }
      })()}
    </div>
  );
};

export default SurveyItemComponent;
